import React, { Suspense } from 'react'
import { Loading } from '@pandiafi/design-system'
import { Navigate } from 'react-router-dom'

import { ErrorHandler } from '../PaymentInformation/PaymentInformationErrorHandler'
import { PaidRightOfOccupancyFee } from './PaidRightOfOccupancyFee/PaidRightOfOccupancyFee'
import { WaitingForPaymentRightOfOccupancyFee } from './WaitingForPaymentRightOfOccupancyFee/WaitingForPaymentRightOfOccupancyFee'
import { WaitingForRefundRightOfOccupancyFee } from './WaitingForRefundRightOfOccupancyFee/WaitingForRefundRightOfOccupancyFee'

import { useAPIGetContractRightOfOccupancyFeeSuspense } from 'api/apiHooks/useAPIGetContractRightOfOccupancyFee'
import { useContractPaths } from 'hooks/useContractPaths/useContractPaths'
import { useCurrentContract } from 'hooks/useCurrentContract/useCurrentContract'

const RightOfOccupancyFeeContent: React.FC = () => {
  const { currentContractId } = useCurrentContract()
  const { paymentHistoryPath } = useContractPaths()
  const { data: fee } =
    useAPIGetContractRightOfOccupancyFeeSuspense(currentContractId)

  if (!fee) return <Navigate to={paymentHistoryPath} replace />

  switch (fee.status) {
    case 'paid':
      return <PaidRightOfOccupancyFee fee={fee} />
    case 'waitingForPayment':
      return <WaitingForPaymentRightOfOccupancyFee fee={fee} />
    case 'waitingForRefund':
      return <WaitingForRefundRightOfOccupancyFee fee={fee} />
  }
}

export const RightOfOccupancyFee: React.FC = () => (
  <Suspense fallback={<Loading variant="details" />}>
    <ErrorHandler>
      <RightOfOccupancyFeeContent />
    </ErrorHandler>
  </Suspense>
)
